/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LLMMessageType {
  MESSAGE = "MESSAGE",
  REASONING = "REASONING",
  TOOL_CALL = "TOOL_CALL",
  TOOL_RESULT = "TOOL_RESULT",
}

export const LLMMessageTypeDisplay: Record<LLMMessageType, string> = {
  [LLMMessageType.MESSAGE]: "Message",
  [LLMMessageType.REASONING]: "Reasoning",
  [LLMMessageType.TOOL_CALL]: "function_call",
  [LLMMessageType.TOOL_RESULT]: "function_call_output",
};
